export const validateOrganizationForm = (validator, data) => {

    validator.setValidation([{
        field: "organizationName",
        method: 'isEmpty',
        validWhen: false,
        message: 'Organization is required'
    }]);
    return validator.validate(data);
}